import type { FC, PropsWithChildren } from 'react';
import React from 'react';

import { AppLayoutBreakpoint, useContainerWidth } from '../../../../util/responsiveness';
import { FlexItem } from '../../../Flex';
import AppLayoutRow from '../../AppLayoutRow';
import { useAppLayoutContext, useContentContainerContext } from '../../hooks';

import type { SubHeaderRowProps } from './SubHeaderRow.types';

const subHeaderHeight = 50;

const SubHeaderRow: FC<PropsWithChildren<SubHeaderRowProps>> = ({ children, forceVisibleAtAllBreakpoints }) => {
  const { shouldShowSubHeaderAtAllBreakpoints } = useContentContainerContext();
  const isLeftNavCollapsible = useAppLayoutContext()?.isLeftNavCollapsible ?? false;

  const width = useContainerWidth();
  const shouldShowInCurrentWidth = shouldShowSubheaderAtWidth(width, isLeftNavCollapsible);
  const shouldRender =
    children && (shouldShowInCurrentWidth || forceVisibleAtAllBreakpoints || shouldShowSubHeaderAtAllBreakpoints);

  if (!shouldRender) {
    return null;
  }

  return (
    <AppLayoutRow height={subHeaderHeight} zIndex={3} layoutRegion="app-subheader">
      <FlexItem grow={1} height={subHeaderHeight}>
        {children}
      </FlexItem>
    </AppLayoutRow>
  );
};

export default SubHeaderRow;

export const shouldShowSubheaderAtWidth = (width: number, isLeftNavCollapsible: boolean): boolean => {
  const breakpoint = isLeftNavCollapsible ? AppLayoutBreakpoint.Width632 : AppLayoutBreakpoint.Width812;

  return width < breakpoint;
};
